<template>
  <v-list-item
    :ripple="true"
    class="mb-1 rounded-lg"
    :active="false"
    :hover="true"
    :class="{
      'bg-grey-lighten-5': !user.active,
      'bg-blue-lighten-5 hover:bg-blue-lighten-4':
        user.active && !isCurrentUser,
      'bg-green-lighten-5 hover:bg-green-lighten-4':
        user.active && isCurrentUser,
    }"
  >
    <template #prepend>
      <UserAvatar :user="user" size="32" class="mr-3" />
    </template>

    <v-list-item-title class="text-body-1">
      {{ user.name }}
    </v-list-item-title>

    <v-list-item-subtitle class="text-body-2 text-medium-emphasis">
      {{ user.email }}
    </v-list-item-subtitle>

    <v-list-item-subtitle>
      <div class="d-flex flex-wrap gap-1 mb-1">
        <v-chip
          v-for="role in user.roles"
          :key="role"
          size="x-small"
          class="primary mr-1"
        >
          {{ role }}
        </v-chip>
      </div>

      <!-- Tenant memberships display -->
      <div v-if="userTenants.length > 0" class="d-flex flex-wrap gap-1">
        <v-chip
          v-for="tenant in userTenants"
          :key="tenant.id"
          size="x-small"
          color="info"
          variant="outlined"
          class="mr-1"
          prepend-icon="mdi-domain"
        >
          {{ tenant.name }}
        </v-chip>
      </div>
      <div
        v-else-if="tenantsStore.tenants.length > 0"
        class="text-caption text-grey-darken-1"
      >
        Geen tenant toegewezen
      </div>
    </v-list-item-subtitle>

    <template #append>
      <div class="d-flex align-center">
        <v-chip
          :color="user.active ? 'success' : 'grey'"
          :variant="user.active ? 'flat' : 'tonal'"
          size="x-small"
          class="mr-3 px-2"
          label
        >
          <span class="text-caption">{{
            user.active ? "Actief" : "Inactief"
          }}</span>
        </v-chip>
        <UserOptions :user="user" />
      </div>
    </template>
  </v-list-item>
</template>

<script>
import { defineComponent, computed } from "vue";
import UserAvatar from "./UserAvatar.vue";
import UserOptions from "./UserOptions.vue";
import { useAuthStoreRefactor } from "@/stores/authStoreRefactor";
import { useTenantsStoreRefactor } from "@/stores/tenantsStoreRefactor";

export default defineComponent({
  name: "UserListItem",
  components: {
    UserAvatar,
    UserOptions,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const authStore = useAuthStoreRefactor();
    const tenantsStore = useTenantsStoreRefactor();

    const isCurrentUser = computed(() => {
      return authStore.user?.id === props.user.id;
    });

    const userTenants = computed(() => {
      if (!props.user.tenant_ids || !Array.isArray(props.user.tenant_ids)) {
        return [];
      }

      return props.user.tenant_ids
        .map((tenantId) => tenantsStore.getTenantById(tenantId))
        .filter(Boolean); // Remove any undefined tenants
    });

    return {
      isCurrentUser,
      userTenants,
      tenantsStore,
    };
  },
});
</script>
